import { inject, Injectable, Optional, SkipSelf } from '@angular/core';
import { Functions, HttpsCallableOptions, httpsCallable } from '@angular/fire/functions';

export type Result<T> = Promise<T>;

@Injectable({ providedIn: 'root' })
export class FunctionsApiService {
  private functions = inject(Functions);

  constructor(@Optional() @SkipSelf() thisService?: FunctionsApiService) {
    if (thisService) throw new Error('Multiple instances of FunctionsApiService');
  }

  public callFunction<T>(funcName: string, params: any, onReject?: (reason: any) => void): Result<T> {
    const call = httpsCallable<any, T>(this.functions, funcName);
    return call(params).then(
      (x) => x.data,
      (reason) => {
        console.warn(`Rejected ${funcName}: ${reason}`);
        if (onReject) onReject(reason);
        return {} as T;
      }
    );
  }

  public callFunctionOrThrow<TReq, TRes>(funcName: string, params: TReq, options?: HttpsCallableOptions): Result<TRes> {
    const call = httpsCallable<TReq, TRes>(this.functions, funcName, options);
    return call(params).then((x) => x.data);
  }
}
